import { WorkImage } from "../types";

export const workImages: WorkImage[] = [
  {
    src: "/images/Work1.png",
    alt: "Business Analytics Dashboard",
    title: "Mindful Life Branding",
    description:
      "Mindful Life is a self-initiated project aimed at creating a cohesive brand identity for a meditation and wellness platform. The design focuses on a calm, minimal aesthetic, reflecting mindfulness through soft color palettes, elegant typography and intuitive layouts. We ensured brand consistency across the logo, UI design, and visual elements, enhancing the overall experience.",
  },
  {
    src: "/images/Work2.png",
    alt: "Creative Design Workshop",
    title: "ShredFast Branding Indentity",
    description:
      "We created a unique and energetic branding look for ShredFast, including a bold visual identity and a dynamic app header design that reflects the intensity and discipline of the fitness lifestyle.",
  },
  {
    src: "/images/Work3.png",
    alt: "Mobile App Development",
    title: "ShredFast Branding Indentity",
    description:
      "We created a unique and energetic branding look for ShredFast, including a bold visual identity and a dynamic app header design that reflects the intensity and discipline of the fitness lifestyle.",
  },
  {
    src: "/images/Work6.png",
    alt: "Web Development Project",
    title: "Mindful Life Mobile App",
    description:
      "Mindful Life is a self-initiated project aimed at creating a cohesive brand identity for a meditation and wellness platform. The design focuses on a calm, minimal aesthetic, reflecting mindfulness through soft color palettes, elegant typography and intuitive layouts. We ensured brand consistency across the logo, UI design, and visual elements, enhancing the overall experience.",
  },
  {
    src: "/images/Work5.png",
    alt: "Digital Marketing Campaign",
    title: "Mindful Life Web App",
    description:
      "We designed the web version of Mindful Life, integrating AI-powered, science-based articles, guided journaling, and meditation sessions to support users on their journey to inner peace and well-being.",
  },
  {
    src: "/images/Work4.png",
    alt: "Brand Identity Design",
    title: "ShredFast Fitness Mobile App",
    description:
      "ShredFast, a UK-based fitness brand, needed a modern, engaging UI to enhance user experience. Our focus was on revamping the mobile app, creating a clean, structured layout that improves navigation and usability. Through user research and A/B testing, We refined the design to ensure better engagement, accessibility, and conversion rates.",
  },
];
